import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/dashboard/page.tsx");
